<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
                <li>{{ pageTitle.subTitle }}</li>
            </ul>
        </div>
    </div>
    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="courses-details-area pb-100">
    <div class="courses-details-image">
        <img src="assets/img/courses/courses-details.jpg" alt="image" />
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="courses-details-desc">
                    <ul
                        class="nav nav-tabs"
                        id="myTab"
                        role="tablist"
                        *ngIf="this.pageData != 'kepler-introduction'"
                    >
                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link active"
                                id="overview-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#overview"
                                type="button"
                                role="tab"
                                aria-controls="overview"
                                aria-selected="true"
                            >
                                Overview
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link"
                                id="prerequisites-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#instructor"
                                type="button"
                                role="tab"
                                aria-controls="instructor"
                                aria-selected="false"
                            >
                                Prerequisites
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link"
                                id="topics-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#curriculum"
                                type="button"
                                role="tab"
                                aria-controls="curriculum"
                                aria-selected="false"
                            >
                                Topics Covered
                            </button>
                        </li>
                        <li
                            *ngIf="this.pageData === 'university-snowflake'"
                            class="nav-item"
                            role="presentation"
                        >
                            <button
                                class="nav-link"
                                id="additional-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#additional"
                                type="button"
                                role="tab"
                                aria-controls="additional"
                                aria-selected="false"
                            >
                                Additional Resources
                            </button>
                        </li>
                    </ul>
                    <div
                        class="courses-overview"
                        *ngIf="this.pageData === 'kepler-introduction'"
                    >
                        <h3>Overview</h3>
                        <p>Learning can happen anywhere, anytime</p>
                        <p>
                            This University is always open for learning. There
                            are several online classes and hands-on labs
                            available to users and consumers of data.
                        </p>
                        <p>
                            Data Producers are people that are on the front
                            lines, that enter data into the systems. The Data
                            Producers control the instruments that are used for
                            physical data production if that data is produced
                            from within the organization or if that data is
                            produced by an outside source.
                        </p>
                        <p>
                            Data Consumers are the people that use data as part
                            of their job. Data Users include people that request
                            and use data on reports to make decisions. Data
                            Users are people that analyze and assess the
                            organization’s operations based on data they receive
                            through a variety of channels. Data Users are a
                            creative lot that are always looking for better ways
                            to use the data to complete their job function.
                        </p>
                        <p>
                            See below for a list of courses offered for Users
                            and Consumers to begin learning.
                        </p>
                        <p>
                            And remember, the learning doesn’t stop here. The
                            Community of Practice is a great place to
                            collaborate with other data producers and consumers
                            to learn and share experience.
                        </p>
                    </div>
                    <div
                        *ngIf="this.pageData === 'documentation'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <h3>Overview</h3>
                                <p>Learning can happen anywhere, anytime</p>
                                <p>
                                    This University is always open for learning.
                                    There are several online classes and
                                    hands-on labs available to users and
                                    consumers of data.
                                </p>
                                <p>
                                    Data Producers are people that are on the
                                    front lines, that enter data into the
                                    systems. The Data Producers control the
                                    instruments that are used for physical data
                                    production if that data is produced from
                                    within the organization or if that data is
                                    produced by an outside source.
                                </p>
                                <p>
                                    Data Consumers are the people that use data
                                    as part of their job. Data Users include
                                    people that request and use data on reports
                                    to make decisions. Data Users are people
                                    that analyze and assess the organization’s
                                    operations based on data they receive
                                    through a variety of channels. Data Users
                                    are a creative lot that are always looking
                                    for better ways to use the data to complete
                                    their job function.
                                </p>
                                <p>
                                    See below for a list of courses offered for
                                    Users and Consumers to begin learning.
                                </p>
                                <p>
                                    And remember, the learning doesn’t stop
                                    here. The Community of Practice is a great
                                    place to collaborate with other data
                                    producers and consumers to learn and share
                                    experience.
                                </p>
                            </div>
                            <div class="courses-overview">
                                <h3>Course Description</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <h3>Certification</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <h3>Who this course is for</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Python Introduction</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python Introduction</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >5 questions</span
                                                >
                                                <span class="duration"
                                                    >01 Hour</span
                                                >
                                                <span class="status"
                                                    >Preview</span
                                                >
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <h3>Stepping into the World of Python</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Introduction</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >15 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Getting Started</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >30 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Creating Arrays</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >45 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Array Indexing</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >4 questions</span
                                                >
                                                <span class="duration"
                                                    >1 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Array Slicing</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >1.5 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <h3>Python MySQL</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >01 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL Create
                                                Database</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >3 questions</span
                                                >
                                                <span class="duration"
                                                    >1.1 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL Create Table</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >1.5 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="advisor-image">
                                                <img
                                                    src="assets/img/speaker/img2.jpg"
                                                    alt="image"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-lg-8 col-md-8">
                                            <div class="advisor-content">
                                                <h3>Sarah Taylor</h3>
                                                <span class="sub-title"
                                                    >Agile Project Expert</span
                                                >
                                                <ul class="social-link">
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-facebook"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-twitter"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-instagram"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-linkedin"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="tab-pane fade" id="reviews" role="tabpanel" >
                            <div class="courses-reviews">
                                <h3>Course Rating</h3>
                                <div class="rating">
                                    <span class="bx bxs-star checked"></span>
                                    <span class="bx bxs-star checked"></span>
                                    <span class="bx bxs-star checked"></span>
                                    <span class="bx bxs-star checked"></span>
                                    <span class="bx bxs-star"></span>
                                </div>
                                <div class="rating-count">
                                    <span>4.1 average based on 4 reviews.</span>
                                </div>
                                <div class="row">
                                    <div class="side">
                                        <div>5 star</div>
                                    </div>
                                    <div class="middle">
                                        <div class="bar-container">
                                            <div class="bar-5"></div>
                                        </div>
                                    </div>
                                    <div class="side right">
                                        <div>02</div>
                                    </div>
                                    <div class="side">
                                        <div>4 star</div>
                                    </div>
                                    <div class="middle">
                                        <div class="bar-container">
                                            <div class="bar-4"></div>
                                        </div>
                                    </div>
                                    <div class="side right">
                                        <div>03</div>
                                    </div>
                                    <div class="side">
                                        <div>3 star</div>
                                    </div>
                                    <div class="middle">
                                        <div class="bar-container">
                                            <div class="bar-3"></div>
                                        </div>
                                    </div>
                                    <div class="side right">
                                        <div>04</div>
                                    </div>
                                    <div class="side">
                                        <div>2 star</div>
                                    </div>
                                    <div class="middle">
                                        <div class="bar-container">
                                            <div class="bar-2"></div>
                                        </div>
                                    </div>
                                    <div class="side right">
                                        <div>05</div>
                                    </div>
                                    <div class="side">
                                        <div>1 star</div>
                                    </div>
                                    <div class="middle">
                                        <div class="bar-container">
                                            <div class="bar-1"></div>
                                        </div>
                                    </div>
                                    <div class="side right">
                                        <div>00</div>
                                    </div>
                                </div>
                            </div>
                            <div class="courses-review-comments">
                                <h3>3 Reviews</h3>
                                <div class="user-review">
                                    <img src="assets/img/user1.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                        </div>
                                        <span class="d-inline-block">James Anderson</span>
                                    </div>
                                    <span class="d-block sub-comment">Excellent</span>
                                    <p>Very well built theme, couldn't be happier with it. Can't wait for future updates to see what else they add in.</p>
                                </div>
                                <div class="user-review">
                                    <img src="assets/img/user2.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star'></i>
                                            <i class='bx bxs-star'></i>
                                        </div>
                                        <span class="d-inline-block">Sarah Taylor</span>
                                    </div>
                                    <span class="d-block sub-comment">Video Quality!</span>
                                    <p>Was really easy to implement and they quickly answer my additional questions!</p>
                                </div>
                                <div class="user-review">
                                    <img src="assets/img/user3.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                        </div>
                                        <span class="d-inline-block">David Warner</span>
                                    </div>
                                    <span class="d-block sub-comment">Perfect Coding!</span>
                                    <p>Stunning design, very dedicated crew who welcome new ideas suggested by customers, nice support.</p>
                                </div>
                                <div class="user-review">
                                    <img src="assets/img/user4.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star checked'></i>
                                            <i class='bx bxs-star'></i>
                                        </div>

                                        <span class="d-inline-block">King Kong</span>
                                    </div>
                                    <span class="d-block sub-comment">Perfect Video!</span>
                                    <p>Stunning design, very dedicated crew who welcome new ideas suggested by customers, nice support.</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div
                        *ngIf="this.pageData === 'Kepler-data-eng'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    The courses prepare Data Engineers to make
                                    data accessible so the organizations can use
                                    it to evaluate and optimize performance.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Snowflake</h3>
                                <ul>
                                    <li>
                                        <a
                                            routerLink="/university-snowflake"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Zero to Snowflake</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                                <h3>Azure</h3>
                                <ul>
                                    <li>
                                        <a
                                            routerLink="/azure-dataexplorer"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Azure Data Explorer (ADX)</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            routerLink="/azure-datafactory"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Azure Data Factory (ADF)</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            routerLink="/azure-createdatafactory"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Azure Data Factory - Create a
                                                data factory</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            routerLink="/azure-createpipeline"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Azure Data Factory - Creating
                                                and Managing Data
                                                Pipelines</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            routerLink="/azure-databricks"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Azure - Explore
                                                Databricks</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                                <h3>Red Hat OpenShift</h3>
                                <ul>
                                    <li>
                                        <a
                                            routerLink="/openshift-foundation"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Foundations of OpenShift
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            routerLink="/openshift-basics"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Azure Red Hat OpenShift Basics
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                                <h3>Airflow</h3>
                                <ul>
                                    <li>
                                        <a
                                            routerLink="/university-airflow-training"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Airflow - Introduction
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <a
                                                    routerLink="/university-kepler"
                                                    class="d-flex justify-content-between align-items-center"
                                                >
                                                    <span class="courses-name"
                                                        >Kepler -
                                                        Introduction</span
                                                    >
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'university-kepler'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <p>
                                    This entry-level overview is designed for
                                    data engineers and data analysts as a basic
                                    introduction to the Kepler Platform.
                                </p>
                            </div>
                            <!-- <div class="courses-overview">
                                <h3>Course Description</h3>
                                <p>Basic knowledge of data constructs, database concepts, and objects.</p>
                            </div> -->
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Kepler</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Data Warehouse Platform
                                                Structure</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">15 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kepler Zones for
                                                Structured/Semi-Structured
                                                Data</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">15 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kepler Data Warehouse for High
                                                Frequency/Streaming Data</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">30 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Data Promotion</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">45 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kepler Portal Overview</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="questions">4 questions</span>
                                            <span class="duration">1 Hour</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kepler Requests</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">1.5 Hour</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Data Ingestion</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">1.5 Hour</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul style="margin-left: 20px">
                                            <li>
                                                <p>
                                                    Basic knowledge of data
                                                    constructs, database
                                                    concepts, and objects.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'university-kepler-deeper'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <p>
                                    This advanced course is designed for data
                                    engineers and data analysts as a deeper
                                    diver into the Kepler Platform.
                                </p>
                            </div>
                            <!-- <div class="courses-overview">
                                <h3>Course Description</h3>
                                <p>Basic knowledge of data constructs, database concepts, and objects.</p>
                            </div> -->
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Kepler</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kepler Zones</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">15 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kepler Data Warehouse
                                            </span>
                                            <!-- <div class="courses-meta">
                                            <span class="duration">15 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Data Visualization</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">30 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kepler Compute</span
                                            >
                                            <!-- <div class="courses-meta">
                                            <span class="duration">45 Min</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Developer Tools
                                            </span>
                                            <!-- <div class="courses-meta">
                                            <span class="questions">4 questions</span>
                                            <span class="duration">1 Hour</span>
                                            <span class="status locked"><i class='flaticon-lock'></i></span>
                                        </div> -->
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul style="margin-left: 20px">
                                            <li>
                                                <p>
                                                    <a href="/university-kepler"
                                                        >Introduction to
                                                        Kepler</a
                                                    >
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'university-snowflake'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <p>
                                    This entry-level guide designed for database
                                    and data warehouse administrators and
                                    architects will help you navigate the
                                    Snowflake interface and introduce you to
                                    some of our core capabilities.
                                </p>
                            </div>
                            <!-- <div class="courses-overview">
                                <h3>Course Description</h3>
                                <p>Basic knowledge of data constructs, database concepts, and objects.</p>
                            </div> -->
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Snowflake</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Creating stages, databases,
                                                tables, views, and virtual
                                                warehouses.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Loading structured and
                                                semi-structured data.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Performing analytical queries
                                                including joins between
                                                tables.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Cloning objects.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Undoing user errors using Time
                                                Travel.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Creating roles and users and
                                                granting privileges.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Sharing data securely and
                                                easily.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Consuming datasets in the
                                                Snowflake Data
                                                Marketplace.</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <p></p>
                                        <ul>
                                            <li>
                                                <p>
                                                    Basic knowledge of SQL,
                                                    database concepts, and
                                                    objects.
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Familiarity with CSV
                                                    comma-delimited files and
                                                    JSON semi-structured data.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="additional"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <a
                                                    target="_blank"
                                                    href="https://quickstarts.snowflake.com/guide/visual_analytics_powered_by_snowflake_and_tableau/index.html?index=..%2F..index#0"
                                                    class="d-flex justify-content-between align-items-center"
                                                >
                                                    <span class="courses-name"
                                                        >Snowflake and
                                                        Tableau</span
                                                    >
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'snowflake-datawarehousing'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    This course is the first in the Hands On
                                    Essentials Series. This series allows you to
                                    earn a Badge for display on LinkedIn and
                                    other social media. The Essentials Series
                                    uses active learning principles to give you
                                    a fast paced, hands on experience. Short
                                    videos, step-by-step labs, reflection
                                    questions, and challenge labs work together
                                    to build your knowledge and skills as you
                                    build a solution.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Snowflake - Data Warehousing</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Benefits of a Cloud-based
                                                Database</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Account Editions, Regions &
                                                Clouds</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Snowflake Identity, Access,
                                                Users, & Roles</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Databases, Ownership, and
                                                Context</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Worksheets and Warehouses
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Loading Tables Using SQL Insert
                                                Statements</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >File Formats, Stages, and Copy
                                                Into Loading</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Semi-Structured Data including
                                                XML and JSON</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Querying Nested Semi-Structured
                                                Data</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <p>
                                            As our flagship course, there are no
                                            prerequisites. You should know how
                                            to use a web browser but beyond
                                            that, you don't need to even need to
                                            know what a database is!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'snowflake-datavisualization'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    A Snowflake Warehouse is a virtual warehouse
                                    consisting of one or more compute clusters
                                    that enable customers to execute queries,
                                    load data, and perform other DML operations.
                                    Snowflake credits are used to pay for the
                                    processing time used by each virtual
                                    warehouse. Warehouses are required for
                                    queries, as well as all DML operations,
                                    including loading data into tables.
                                </p>
                                <p>
                                    This course assists you with connecting to
                                    Snowflake for data visualization.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Snowflake - Data Visualization</h3>
                                <ul>
                                    <li>TBD</li>
                                    <!-- <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Benefits of a Cloud-based Database</span>                                        
                                    </a></li>
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Account Editions, Regions & Clouds</span>                                 
                                    </a></li>   
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Snowflake Identity, Access, Users, & Roles</span>                                        
                                    </a></li>
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Databases, Ownership, and Context</span>                                 
                                    </a></li>  
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Worksheets and Warehouses </span>                                        
                                    </a></li>
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Loading Tables Using SQL Insert Statements</span>                                 
                                    </a></li>  
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">File Formats, Stages, and Copy Into Loading</span>                                        
                                    </a></li>
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Semi-Structured Data including XML and JSON</span>                                 
                                    </a></li>  
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Querying Nested Semi-Structured Data</span>                                        
                                    </a></li>                                                                       -->
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <p>TBD</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'Kepler-data-eng-201'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <h3>Overview</h3>
                                <p>Learning can happen anywhere, anytime</p>
                                <p>
                                    This University is always open for learning.
                                    There are several online classes and
                                    hands-on labs available to users and
                                    consumers of data.
                                </p>
                                <p>
                                    Data Producers are people that are on the
                                    front lines, that enter data into the
                                    systems. The Data Producers control the
                                    instruments that are used for physical data
                                    production if that data is produced from
                                    within the organization or if that data is
                                    produced by an outside source.
                                </p>
                                <p>
                                    Data Consumers are the people that use data
                                    as part of their job. Data Users include
                                    people that request and use data on reports
                                    to make decisions. Data Users are people
                                    that analyze and assess the organization’s
                                    operations based on data they receive
                                    through a variety of channels. Data Users
                                    are a creative lot that are always looking
                                    for better ways to use the data to complete
                                    their job function.
                                </p>
                                <p>
                                    See below for a list of courses offered for
                                    Users and Consumers to begin learning.
                                </p>
                                <p>
                                    And remember, the learning doesn’t stop
                                    here. The Community of Practice is a great
                                    place to collaborate with other data
                                    producers and consumers to learn and share
                                    experience.
                                </p>
                            </div>
                            <div class="courses-overview">
                                <h3>Course Description</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <h3>Certification</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <h3>Who this course is for</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Python Introduction</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python Introduction</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >5 questions</span
                                                >
                                                <span class="duration"
                                                    >01 Hour</span
                                                >
                                                <span class="status"
                                                    >Preview</span
                                                >
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <h3>Stepping into the World of Python</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Introduction</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >15 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Getting Started</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >30 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Creating Arrays</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >45 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Array Indexing</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >4 questions</span
                                                >
                                                <span class="duration"
                                                    >1 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Array Slicing</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >1.5 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <h3>Python MySQL</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >01 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL Create
                                                Database</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >3 questions</span
                                                >
                                                <span class="duration"
                                                    >1.1 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL Create Table</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >1.5 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="advisor-image">
                                                <img
                                                    src="assets/img/speaker/img2.jpg"
                                                    alt="image"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-lg-8 col-md-8">
                                            <div class="advisor-content">
                                                <h3>Sarah Taylor</h3>
                                                <span class="sub-title"
                                                    >Agile Project Expert</span
                                                >
                                                <ul class="social-link">
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-facebook"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-twitter"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-instagram"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-linkedin"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'Kepler-data-ana'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    These courses prepare Data Analysts for work
                                    in Kepler reviewing data to help solve
                                    problems using data, learn critical insights
                                    about products and customers and boost
                                    profits.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Snowflake</h3>
                                <ul>
                                    <li>
                                        <a
                                            routerLink="/university-snowflake"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Zero to Snowflake</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                                <h3>Kusto Query Language</h3>
                                <ul>
                                    <li>
                                        <a
                                            routerLink="/university-kusto"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kusto Query Language - Write
                                                Your First Query</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            routerLink="/kusto-insights"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Kusto Query Language - Gain
                                                insights from your data</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <a
                                                    routerLink="/university-kepler"
                                                    class="d-flex justify-content-between align-items-center"
                                                >
                                                    <span class="courses-name"
                                                        >Kepler -
                                                        Introduction</span
                                                    >
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'Kepler-data-ana-201'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <h3>Overview</h3>
                                <p>Learning can happen anywhere, anytime</p>
                                <p>
                                    This University is always open for learning.
                                    There are several online classes and
                                    hands-on labs available to users and
                                    consumers of data.
                                </p>
                                <p>
                                    Data Producers are people that are on the
                                    front lines, that enter data into the
                                    systems. The Data Producers control the
                                    instruments that are used for physical data
                                    production if that data is produced from
                                    within the organization or if that data is
                                    produced by an outside source.
                                </p>
                                <p>
                                    Data Consumers are the people that use data
                                    as part of their job. Data Users include
                                    people that request and use data on reports
                                    to make decisions. Data Users are people
                                    that analyze and assess the organization’s
                                    operations based on data they receive
                                    through a variety of channels. Data Users
                                    are a creative lot that are always looking
                                    for better ways to use the data to complete
                                    their job function.
                                </p>
                                <p>
                                    See below for a list of courses offered for
                                    Users and Consumers to begin learning.
                                </p>
                                <p>
                                    And remember, the learning doesn’t stop
                                    here. The Community of Practice is a great
                                    place to collaborate with other data
                                    producers and consumers to learn and share
                                    experience.
                                </p>
                            </div>
                            <div class="courses-overview">
                                <h3>Course Description</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <h3>Certification</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                                <h3>Who this course is for</h3>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur
                                    adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua.
                                    Quis ipsum suspendisse ultrices gravida.
                                    Risus commodo viverra maecenas accumsan
                                    lacus vel facilisis.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Python Introduction</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python Introduction</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >5 questions</span
                                                >
                                                <span class="duration"
                                                    >01 Hour</span
                                                >
                                                <span class="status"
                                                    >Preview</span
                                                >
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <h3>Stepping into the World of Python</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Introduction</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >15 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Getting Started</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >30 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Creating Arrays</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >45 Min</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Array Indexing</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >4 questions</span
                                                >
                                                <span class="duration"
                                                    >1 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >NumPy Array Slicing</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >1.5 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <h3>Python MySQL</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >01 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL Create
                                                Database</span
                                            >
                                            <div class="courses-meta">
                                                <span class="questions"
                                                    >3 questions</span
                                                >
                                                <span class="duration"
                                                    >1.1 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Python MySQL Create Table</span
                                            >
                                            <div class="courses-meta">
                                                <span class="duration"
                                                    >1.5 Hour</span
                                                >
                                                <span class="status locked"
                                                    ><i
                                                        class="flaticon-lock"
                                                    ></i
                                                ></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <div class="col-lg-4 col-md-4">
                                            <div class="advisor-image">
                                                <img
                                                    src="assets/img/speaker/img2.jpg"
                                                    alt="image"
                                                />
                                            </div>
                                        </div>

                                        <div class="col-lg-8 col-md-8">
                                            <div class="advisor-content">
                                                <h3>Sarah Taylor</h3>
                                                <span class="sub-title"
                                                    >Agile Project Expert</span
                                                >
                                                <ul class="social-link">
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-facebook"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-twitter"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-instagram"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            href="#"
                                                            class="d-block"
                                                            target="_blank"
                                                            ><i
                                                                class="bx bxl-linkedin"
                                                            ></i
                                                        ></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'university-kusto'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <h3>Overview</h3>
                                <p>
                                    Get started by writing simple queries in
                                    Kusto Query Language (KQL) to explore and
                                    gain insights from your data. Learn how to
                                    use the operators take, project, where,
                                    count, sort, and others.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Kusto Query Language</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Write your first query with
                                                KQL.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Use KQL to explore data by
                                                using the most common
                                                operators.</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Familiarity with database
                                                    structures like tables,
                                                    columns, and rows.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'university-mdp'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <h3>Overview</h3>
                                <p>
                                    This entry-level overview is designed for
                                    data engineers and data analysts as a basic
                                    introduction to the MDP Platform.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>MDP - Introduction</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Write your first query with
                                                KQL.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Use KQL to explore data by
                                                using the most common
                                                operators.</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Basic knowledge of data
                                                    constructs, database
                                                    concepts, and objects.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'university-uda'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <h3>Overview</h3>
                                <p>
                                    This entry-level overview is designed for
                                    data engineers and data analysts as a basic
                                    introduction to the UDA Platform.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>UDA(Lakehouse) - Introduction</h3>
                                <ul>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="https://uda-data-platform-rtd.uda.xom.cloud/dataanalytics/datavisualization.html"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Data Visulization</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="https://uda-data-platform-rtd.uda.xom.cloud/dataanalytics/datavisualization.html"
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Data Analytics</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Basic knowledge of data
                                                    constructs, database
                                                    concepts, and objects
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div *ngIf="this.pageData === 'university-uda'" class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="overview" role="tabpanel" >
                            <div class="courses-overview">
                                <h3>Overview</h3>
                                <p>This entry-level overview is designed for data engineers and data analysts as a basic introduction to the UDA Platform.</p>                                
                            </div>                            
                        </div>
                        <div class="tab-pane fade" id="curriculum" role="tabpanel">
                            <div class="courses-curriculum">
                                <h3>UDA(Lakehouse) - Introduction</h3>                                
                                <ul>
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Write your first query with KQL.</span>                                        
                                    </a></li>
                                    <li><a  class="d-flex justify-content-between align-items-center">
                                        <span class="courses-name">Use KQL to explore data by using the most common operators.</span>                                 
                                    </a></li>                                    
                                </ul>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="instructor" role="tabpanel" >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">                                                   
                                        <ul><li><p>Familiarity with database structures like tables, columns, and rows.</p></li></ul>                                      

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div
                        *ngIf="this.pageData === 'kusto-insights'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    Write advanced queries in Kusto Query
                                    Language to help you gain insights from your
                                    data. Use the aggregation functions count,
                                    dcount, countif, sum, min, max, avg,
                                    percentiles, and others. Communicate these
                                    results visually in charts.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>
                                    Kusto Query Language - Gain insights from
                                    your data
                                </h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Gaining insights from data by
                                                using aggregation
                                                functions</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Communicating query results
                                                visually using the render
                                                operator</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Assigning variables by using a
                                                let statement</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Familiarity with database
                                                    structures like tables,
                                                    columns, and rows.
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Familiarity with Kusto Query
                                                    Language operators such as
                                                    count, take, project, where,
                                                    and sort.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'azure-dataexplorer'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    This course describes the ingestion, query,
                                    visualization, and data management features
                                    that Azure Data Explorer provides to help
                                    you make sense of the data flowing into your
                                    business. Determine the types of data
                                    analysis for which Azure Data Explorer is a
                                    good data management platform.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Azure Data Explorer (ADX)</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Overview of Azure Data Explorer
                                                (ADX)</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Explore the features of Azure
                                                Data Explorer (ADX)</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Familiarity with challenges
                                                    of Big Data, such as
                                                    velocity, variety, and
                                                    volume.
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Basic knowledge of query
                                                    language concepts such as
                                                    filters and aggregates.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'azure-datafactory'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    This learning path is an introduction to
                                    Azure Data Factory (ADF) and prepares you
                                    for additional courses on ADF.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Azure Data Factory</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >What is ADF</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >How to use ADF</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >When to use ADF</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Several years of experience
                                                    working with data
                                                    integration.
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Several years of experience
                                                    working with Azure DBaaS
                                                    platforms.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'azure-createdatafactory'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    This course describes using the Azure Data
                                    Factory UI to create and monitor a data
                                    factory. The pipeline that you create in
                                    this data factory copies data from one
                                    folder to another folder in Azure Blob
                                    storage.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>
                                    Azure Data Factory - Create a data factory
                                </h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Understand Azure Data
                                                Factory</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Describe data integration
                                                patterns</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Explain the data factory
                                                process</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Understand Azure Data Factory
                                                components</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Azure Data Factory
                                                security</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Set up Azure Data Factory</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Create linked services</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Create datasets</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Create data factory activities
                                                and pipelines</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Manage integration
                                                runtime</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    You should be able to log
                                                    into the Azure portal
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    You should be able to
                                                    explain and create resource
                                                    groups
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'azure-createpipeline'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    In this learning path, you will learn how to
                                    create and manage data pipelines in the
                                    cloud using Azure Data Factory.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>
                                    Azure Data Factory - Creating and Managing
                                    Data Pipelines
                                </h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Integrate data
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Petabyte-scale ingestion
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Perform code-free
                                                transformation at scale
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Populate slowly changing
                                                dimensions
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Orchestrate data movement and
                                                transformation
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Successfully login to the
                                                    Azure portal
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Understand the Azure storage
                                                    options
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    Understand the Azure compute
                                                    options
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'azure-databricks'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    Azure Databricks is a cloud service that
                                    provides a scalable platform for data
                                    analytics using Apache Spark.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Azure - Explore Databricks</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Provision an Azure Databricks
                                                workspace.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Identify core workloads and
                                                personas for Azure
                                                Databricks.</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Describe key concepts of an
                                                Azure Databricks solution.</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>
                                                    Fundamental knowledge of
                                                    data analytics concepts.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'airflow-training'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Overview</h3> -->
                                <p>
                                    This tutorial walks you through some of the
                                    fundamental Airflow concepts, objects, and
                                    their usage while writing your first
                                    pipeline.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Airflow - Introduction</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Example Pipeline
                                                definition</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >It’s a DAG definition
                                                file</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Importing Modules</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Default Arguments</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Instantiate a DAG</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Tasks</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Templating with Jinja</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Adding DAG and Tasks
                                                documentation</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Setting up Dependencies</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Using time zones</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <p>
                                            There are no prerequisites for this
                                            course.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'openshift-basics'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <!-- <h3>Azure Red Hat OpenShift Basics</h3> -->
                                <p>
                                    A hands-on guide teaching everything from
                                    how to set up your first cluster, to
                                    management, to deploying data services, all
                                    powered by Azure.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Azure Red Hat OpenShift Basics</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Red Hat OpenShift and
                                                Azure</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Setting up a cluster</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Managing the cluster</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Deploying a data service</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <ul>
                                            <li>
                                                <p>Foundations of OpenShift</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="this.pageData === 'openshift-foundation'"
                        class="tab-content"
                        id="myTabContent"
                    >
                        <div
                            class="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                        >
                            <div class="courses-overview">
                                <h3>Foundations of OpenShift</h3>
                                <p>
                                    This course starts with the foundations to
                                    give you hands-on experience creating and
                                    deploying applications in Red Hat OpenShift
                                    in Red Hat's interactive learning
                                    environments.
                                </p>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="curriculum"
                            role="tabpanel"
                        >
                            <div class="courses-curriculum">
                                <h3>Foundation of OpenShift</h3>
                                <ul>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >The basic concepts behind
                                                OpenShift</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Creating and deploying
                                                applications</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Working with Live Coding to
                                                compile and deploy changes</span
                                            >
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            class="d-flex justify-content-between align-items-center"
                                        >
                                            <span class="courses-name"
                                                >Creating data-driven
                                                applications</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="instructor"
                            role="tabpanel"
                        >
                            <div class="courses-instructor">
                                <div class="single-advisor-box">
                                    <div class="row align-items-center">
                                        <!-- <div class="col-lg-4 col-md-4">
                                            <div class="advisor-image">
                                                <img src="assets/img/speaker/img2.jpg" alt="image">
                                            </div>
                                        </div> -->

                                        <!-- <div class="col-lg-8 col-md-8">
                                            <div class="advisor-content">
                                                <h3>Sarah Taylor</h3>
                                                <span class="sub-title">Agile Project Expert</span>
                                                <ul class="social-link">
                                                    <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                                    <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                                    <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                                    <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                                                </ul>
                                            </div>
                                        </div> -->
                                        <p>
                                            There are no prerequisites for this
                                            course.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="courses-details-info">
                    <div class="image">
                        <img
                            src="assets/img/courses/kusto.png"
                            alt="image"
                            *ngIf="this.pageData === 'university-kusto'"
                        />
                        <img
                            src="assets/img/courses/kql-insights-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'kusto-insights'"
                        />
                        <img
                            src="assets/img/courses/azure-dataexp-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'azure-dataexplorer'"
                        />
                        <img
                            src="assets/img/courses/azure-datafactory-preview.jpeg"
                            alt="image"
                            *ngIf="this.pageData === 'azure-datafactory'"
                        />
                        <img
                            src="assets/img/courses/azure-createdata-preview.jpeg"
                            alt="image"
                            *ngIf="this.pageData === 'azure-createdatafactory'"
                        />
                        <img
                            src="assets/img/courses/azure-createpipe-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'azure-createpipeline'"
                        />
                        <img
                            src="assets/img/courses/azure-databricks-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'azure-databricks'"
                        />
                        <img
                            src="assets/img/courses/airflow-training-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'airflow-training'"
                        />
                        <img
                            src="assets/img/courses/openshift-basics-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'openshift-basics'"
                        />
                        <img
                            src="assets/img/courses/openshift-foundation-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'openshift-foundation'"
                        />
                        <img
                            src="assets/img/courses/Kepler-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'university-kepler'"
                        />
                        <img
                            src="assets/img/courses/Kepler-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'university-kepler-deeper'"
                        />
                        <img
                            src="assets/img/courses/snowflake-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'university-snowflake'"
                        />
                        <img
                            src="assets/img/courses/snowflake-dataware-preview.png"
                            alt="image"
                            *ngIf="
                                this.pageData === 'snowflake-datawarehousing'
                            "
                        />
                        <img
                            src="assets/img/courses/snowflake-datavisual-preview.png"
                            alt="image"
                            *ngIf="
                                this.pageData === 'snowflake-datavisualization'
                            "
                        />
                        <img
                            src="assets/img/courses/kepler-data-engineer-preview.jpg"
                            alt="image"
                            *ngIf="this.pageData === 'Kepler-data-eng'"
                        />
                        <img
                            src="assets/img/courses/kepler-data-analyst-preview.jpg"
                            alt="image"
                            *ngIf="this.pageData === 'Kepler-data-ana'"
                        />
                        <img
                            src="assets/img/funfacts/mdp-logo-removebg-preview.png"
                            alt="image"
                            *ngIf="this.pageData === 'university-mdp'"
                        />
                        <img
                            src="assets/img/funfacts/UDA.png"
                            alt="image"
                            style="height: 135px"
                            *ngIf="this.pageData === 'university-uda'"
                        />
                        <!-- <a href="https://www.youtube.com/watch?v=PWvPbGWVRrU" class="link-btn popup-youtube"></a> -->
                        <!-- <div class="content">
                            <i class="flaticon-google-play"></i>
                            <span>Course Preview</span>
                        </div> -->
                    </div>

                    <ul
                        *ngIf="
                            this.pageData != 'Kepler-data-ana' &&
                            this.pageData != 'Kepler-data-eng'
                        "
                        class="info"
                    >
                        <!-- <li class="price">
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-price-tag"></i> Price</span>
                                $49
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="flaticon-teacher"></i> Instructor</span>
                                Sarah Taylor
                            </div>
                        </li> -->
                        <li>
                            <div
                                class="d-flex justify-content-between align-items-center"
                            >
                                <span
                                    ><i class="flaticon-stopwatch"></i>
                                    Duration</span
                                >
                                <p *ngIf="this.pageData == 'university-kepler'">
                                    45 minutes
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'university-kepler-deeper'
                                    "
                                >
                                    45 minutes
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'university-snowflake'
                                    "
                                >
                                    90 minutes
                                </p>
                                <p *ngIf="this.pageData == 'university-azure'">
                                    30 minutes
                                </p>
                                <p *ngIf="this.pageData == 'university-kusto'">
                                    40 minutes
                                </p>
                                <p *ngIf="this.pageData == 'airflow-training'">
                                    4 Hours
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'openshift-foundation'
                                    "
                                >
                                    4 Hours
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'snowflake-datavisualization'
                                    "
                                >
                                    TBD
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'snowflake-datawarehousing'
                                    "
                                >
                                    TBD
                                </p>
                                <p *ngIf="this.pageData == 'kusto-insights'">
                                    50 minutes
                                </p>
                                <p *ngIf="this.pageData == 'openshift-basics'">
                                    1 Hour
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'azure-dataexplorer'
                                    "
                                >
                                    30 minutes
                                </p>
                                <p *ngIf="this.pageData == 'azure-datafactory'">
                                    35 minutes
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'azure-createdatafactory'
                                    "
                                >
                                    1 Hour
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'azure-createpipeline'
                                    "
                                >
                                    6 Hours
                                </p>
                                <p *ngIf="this.pageData == 'azure-databricks'">
                                    45 minutes
                                </p>
                                <p *ngIf="this.pageData == 'university-mdp'">
                                    45 minutes
                                </p>
                                <p *ngIf="this.pageData == 'university-uda'">
                                    45 minutes
                                </p>
                            </div>
                        </li>
                        <li>
                            <div
                                class="d-flex justify-content-between align-items-center"
                            >
                                <span><i class="flaticon-web"></i> Topics</span>
                                <p *ngIf="this.pageData == 'university-kepler'">
                                    7
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'university-kepler-deeper'
                                    "
                                >
                                    6
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'university-snowflake'
                                    "
                                >
                                    8
                                </p>
                                <p *ngIf="this.pageData == 'university-azure'">
                                    3
                                </p>
                                <p *ngIf="this.pageData == 'university-kusto'">
                                    2
                                </p>
                                <p *ngIf="this.pageData == 'airflow-training'">
                                    10
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'openshift-foundation'
                                    "
                                >
                                    4
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'snowflake-datavisualization'
                                    "
                                >
                                    TBD
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'snowflake-datawarehousing'
                                    "
                                >
                                    9
                                </p>
                                <p *ngIf="this.pageData == 'kusto-insights'">
                                    3
                                </p>
                                <p *ngIf="this.pageData == 'openshift-basics'">
                                    4
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'azure-dataexplorer'
                                    "
                                >
                                    2
                                </p>
                                <p *ngIf="this.pageData == 'azure-datafactory'">
                                    3
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData ==
                                        'azure-createdatafactory'
                                    "
                                >
                                    10
                                </p>
                                <p
                                    *ngIf="
                                        this.pageData == 'azure-createpipeline'
                                    "
                                >
                                    5
                                </p>
                                <p *ngIf="this.pageData == 'azure-databricks'">
                                    3
                                </p>
                                <p *ngIf="this.pageData == 'university-mdp'">
                                    TBD
                                </p>
                                <p *ngIf="this.pageData == 'university-uda'">
                                    TBD
                                </p>
                            </div>
                        </li>
                        <li>
                            <div
                                class="d-flex justify-content-between align-items-center"
                            >
                                <span
                                    ><i class="flaticon-distance-education"></i>
                                    Course Type</span
                                >
                                <p>Self-Paced</p>
                            </div>
                        </li>
                    </ul>

                    <div
                        *ngIf="
                            this.pageData != 'Kepler-data-ana' &&
                            this.pageData != 'Kepler-data-eng'
                        "
                        class="btn-box"
                    >
                        <!-- <a routerLink="/courses-details" class="default-btn"><i class="flaticon-shopping-basket"></i>Add to Cart<span></span></a> -->
                        <a
                            target="_blank"
                            [href]="this.courseLink"
                            class="default-btn"
                            ><i class="flaticon-right"></i>Get Started<span
                            ></span
                        ></a>
                    </div>

                    <!-- <div class="courses-share">
                        <div class="share-info">
                            <span>Share This Course <i class="flaticon-share"></i></span>

                            <ul class="social-link">
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</section>

<app-related-courses></app-related-courses>
